import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "mb-5 d-block" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = {
  key: 0,
  class: "f-20"
}
const _hoisted_5 = {
  key: 1,
  class: "f-20"
}
const _hoisted_6 = {
  key: 0,
  class: "col-12"
}
const _hoisted_7 = { class: "mb-4 d-flex justify-content-end col-12 pr-0" }
const _hoisted_8 = { class: "linkform d-flex" }
const _hoisted_9 = { class: "pb-2 pr-4 w-50" }
const _hoisted_10 = { class: "pb-2 w-50" }
const _hoisted_11 = {
  key: 1,
  class: "col-12 d-flex justify-content-end"
}
const _hoisted_12 = { class: "mb-5 favoritenliste d-block" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-12" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "list-group list-unstyled" }
const _hoisted_17 = ["href"]
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "list-group-item mb-0" }
const _hoisted_20 = { class: "d-flex justify-content-between" }
const _hoisted_21 = { class: "d-flex align-items-center" }
const _hoisted_22 = { class: "form-check mr-3" }
const _hoisted_23 = { class: "text" }
const _hoisted_24 = { class: "d-flex" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_draggable = _resolveComponent("draggable")!
  const _component_loading_container = _resolveComponent("loading-container")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_loading_container, {
      state: _ctx.state,
      errormsg: "Beim Laden der Linkliste ist ein Fehler aufgetreten."
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              (!_ctx.changeable)
                ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.textStandard), 1))
                : (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.textEdit), 1))
            ]),
            (_ctx.changeable)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("button", {
                      class: "btn btn-link mr-3",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.cancelList()))
                    }, "Abbrechen"),
                    _createElementVNode("button", {
                      class: "btn btn-primary btn-anwendungen",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.saveList()))
                    }, "Änderungen speichern")
                  ]),
                  _createElementVNode("form", {
                    onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addUrlToList && _ctx.addUrlToList(...args)), ["prevent"]))
                  }, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _cache[8] || (_cache[8] = _createElementVNode("label", {
                          class: "pr-2",
                          for: "externalLinkName"
                        }, "Name: ", -1)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newLinkName) = $event)),
                          type: "text",
                          class: "mr-4 form-control",
                          id: "externalLinkName",
                          name: "externalLinkName",
                          placeholder: ""
                        }, null, 512), [
                          [_vModelText, _ctx.newLinkName]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _cache[9] || (_cache[9] = _createElementVNode("label", {
                          class: "pr-2",
                          for: "externalLink"
                        }, "Link: ", -1)),
                        _withDirectives(_createElementVNode("input", {
                          class: "mb-2 form-control",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newLink) = $event)),
                          type: "url",
                          id: "externalLink",
                          name: "externalLink",
                          placeholder: "https://..."
                        }, null, 512), [
                          [_vModelText, _ctx.newLink]
                        ])
                      ])
                    ]),
                    _cache[10] || (_cache[10] = _createElementVNode("button", {
                      type: "submit",
                      class: "mb-4 btn btn-primary"
                    }, "Link hinzufügen", -1))
                  ], 32)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("button", {
                    class: "btn btn-primary btn-anwendungen",
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.changechange && _ctx.changechange(...args)))
                  }, "Linkliste bearbeiten")
                ]))
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              (!_ctx.changeable)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("ul", _hoisted_16, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item) => {
                        return (_openBlock(), _createElementBlock("li", {
                          class: "list-group-item mb-0",
                          key: item.id
                        }, [
                          _createElementVNode("template", null, [
                            _createElementVNode("a", {
                              href: _ctx.sanitizeUrl(item.resolvedUrl || item.externalUrl),
                              class: "d-flex align-items-center fs-16",
                              target: "_blank",
                              rel: "noreferrer noopener"
                            }, [
                              _createElementVNode("div", null, _toDisplayString(item.resolvedName || item.name), 1),
                              _cache[11] || (_cache[11] = _createElementVNode("div", null, [
                                _createElementVNode("i", { class: "fas fa-external-link-alt ml-2 fs-12" }),
                                _createElementVNode("span", { class: "sr-only" }, "öffnen")
                              ], -1))
                            ], 8, _hoisted_17)
                          ])
                        ]))
                      }), 128))
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _createVNode(_component_draggable, _mergeProps({
                      tag: "ul",
                      list: _ctx.list,
                      class: "list-group list-unstyled",
                      handle: ".handle"
                    }, _ctx.dragOptions, {
                      onStart: _cache[6] || (_cache[6] = ($event: any) => (_ctx.drag = true)),
                      onEnd: _cache[7] || (_cache[7] = ($event: any) => (_ctx.drag = false)),
                      "item-key": "name"
                    }), {
                      item: _withCtx(({ element, index }) => [
                        _createElementVNode("li", _hoisted_19, [
                          _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("div", _hoisted_21, [
                              _cache[12] || (_cache[12] = _createElementVNode("i", {
                                class: "fas fa-grip-horizontal handle mr-3",
                                "aria-hidden": "true"
                              }, null, -1)),
                              _createElementVNode("div", _hoisted_22, [
                                _createElementVNode("span", _hoisted_23, _toDisplayString(element.resolvedName || element.name), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_24, [
                              (index > 0)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: "btn btn-arrow py-0 fs-12",
                                    onClick: ($event: any) => (_ctx.moveUp(index))
                                  }, [...(_cache[13] || (_cache[13] = [
                                    _createElementVNode("i", { class: "fas fa-long-arrow-alt-up" }, null, -1)
                                  ]))], 8, _hoisted_25))
                                : _createCommentVNode("", true),
                              (index < (_ctx.list.length -1))
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 1,
                                    class: "btn btn-arrow py-0 fs-12",
                                    onClick: ($event: any) => (_ctx.moveDown(index))
                                  }, [...(_cache[14] || (_cache[14] = [
                                    _createElementVNode("i", { class: "fas fa-long-arrow-alt-down" }, null, -1)
                                  ]))], 8, _hoisted_26))
                                : _createCommentVNode("", true),
                              _createElementVNode("button", {
                                class: "loeschen-btn",
                                type: "button",
                                title: "Link entfernen",
                                onClick: ($event: any) => (_ctx.deleteFavorite(index))
                              }, [...(_cache[15] || (_cache[15] = [
                                _createElementVNode("i", { class: "icon icon-loeschen" }, null, -1)
                              ]))], 8, _hoisted_27)
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }, 16, ["list"])
                  ]))
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["state"])
  ]))
}